import styles from './ReleaseNoteItems.module.css';
import Icon from '../../components/common/Icon';

export interface ReleaseNoteFileVM {
  s3Key: string;
  fileName: string;
  mimeType: string;
  fileSize: number;
  url: string | null;
}

export interface ReleaseNoteItemVM {
  title: string;
  description: string;
  files: ReleaseNoteFileVM[];
}

const FilePreview = ({ file }: { file: ReleaseNoteFileVM }) => {
  if (!file.url) return null;
  if (file.mimeType.startsWith('image/')) {
    return (
      <a href={file.url} target="_blank" rel="noreferrer" className={styles.mediaWrap} title={file.fileName}>
        <img src={file.url} alt={file.fileName} className={styles.mediaImg} loading="lazy" />
      </a>
    );
  }
  if (file.mimeType.startsWith('video/')) {
    return (
      <video src={file.url} controls preload="metadata" className={styles.mediaVideo} title={file.fileName} />
    );
  }
  return (
    <a href={file.url} target="_blank" rel="noreferrer" className={styles.fileLink}>
      <Icon name="attach_file" className="text-base" />
      {file.fileName}
    </a>
  );
};

const ReleaseNoteItems = ({ items }: { items: ReleaseNoteItemVM[] }) => (
  <div className="space-y-4">
    {items.map((item, i) => (
      <div key={i} className={styles.itemCard}>
        <h3 className={styles.itemTitle}>{item.title}</h3>
        {item.description && <p className={styles.itemDescription}>{item.description}</p>}
        {item.files.length > 0 && (
          <div className={styles.mediaGrid}>
            {item.files.map((f) => (
              <FilePreview key={f.s3Key} file={f} />
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
);

export default ReleaseNoteItems;
